import React from "react";

function Navbar() {
  const [show, setShow] = React.useState(false);
  return (
    <div
      id="kt_body"
      data-bs-spy="scroll"
      data-bs-target="#kt_landing_menu"
      data-bs-offset="200"
      className="bg-white sticky-top w-100 z-index-3"
    >
      <div className="d-flex flex-column flex-root">
        <div className="mb-0" id="home">
          <div className="bgi-no-repeat bgi-size-cover bgi-position-x-center bgi-position-y-bottom landing-light-bg">
            <div
              className="landing-header"
              data-kt-sticky="true"
              data-kt-sticky-name="landing-header"
              data-kt-sticky-offset="{default: '200px', lg: '300px'}"
            >
              <div className="container">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center flex-equal">
                    <button
                      className="btn btn-icon btn-active-color-dark me-3 d-flex d-lg-none"
                      id="kt_landing_menu_toggle"
                      onClick={() => setShow(!show)}
                    >
                      <span className="svg-icon svg-icon-2hx">
                        <svg
                          xmlns={"http://www.w3.org/2000/svg"}
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                            fill="black"
                          />
                          <path
                            opacity="0.3"
                            d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </button>

                    <a className="d-none d-lg-block" href="/">
                      <img
                        alt="Logo"
                        src="./assets/media/logos/3rdretaillogoblue.svg"
                        className="logo-default h-100px h-lg-100px"
                      />
                      {/* <img
                        alt="Logo"
                        src="./assets/media/logos/3rdretaillogoblue.svg"
                        className="logo-sticky h-100px h-lg-100px"
                      /> */}
                    </a>
                  </div>

                  <div
                    className="d-lg-block"
                    id="kt_header_nav_wrapper menu-classic menu-fixed menu-transparent  align-right"
                    data-menu-anima="fade-in"
                  >
                    <div
                      className={`d-lg-block p-5 p-lg-0 ${
                        show ? "drawer drawer-start drawer-on" : ""
                      }`}
                      data-kt-drawer="true"
                      data-kt-drawer-name="landing-menu"
                      data-kt-drawer-activate="{default: true, lg: false}"
                      data-kt-drawer-overlay="true"
                      data-kt-drawer-width="200px"
                      data-kt-drawer-direction="start"
                      data-kt-drawer-toggle="#kt_landing_menu_toggle"
                      data-kt-swapper="true"
                      data-kt-swapper-mode="prepend"
                      data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav_wrapper'}"
                    >
                      <div
                        className="menu menu-column flex-nowrap menu-rounded menu-lg-row  menu-state-title-primary nav nav-flush fs-5 fw-bold"
                        id="kt_landing_menu"
                      >
                        <i
                          className="bi bi-x-circle text-dark d-lg-none text-end fs-2x"
                          onClick={() => setShow(false)}
                        ></i>
                        <div className="menu-item">
                          <a
                            className="menu-link nav-link  py-3 px-5 px-xxl-6"
                            href="/Pagenotfound.html"
                            data-kt-scroll-toggle="true"
                            data-kt-drawer-dismiss="true"
                          >
                            Brands
                          </a>
                        </div>

                        <div className="menu-item">
                          <a
                            className="menu-link nav-link py-3 px-5 px-xxl-6"
                            href="/Pagenotfound.html"
                            data-kt-scroll-toggle="true"
                            data-kt-drawer-dismiss="true"
                          >
                            Resellers
                          </a>
                        </div>

                        <div className="menu-item">
                          <a
                            className="menu-link nav-link py-3 px-5 px-xxl-6"
                            href="/Pagenotfound.html"
                            rel="noreferrer"
                            data-kt-scroll-toggle="true"
                            data-kt-drawer-dismiss="true"
                            target={"_blank"}
                          >
                            Marketplace
                          </a>
                        </div>

                        {/* <div className='menu-item'>
                          <a
                            className='menu-link nav-link py-3 px-5 px-xxl-6'
                            href='#team'
                            data-kt-scroll-toggle='true'
                            data-kt-drawer-dismiss='true'
                          >
                            About Us
                          </a>
                        </div> */}

                        <div className="menu-item">
                          <a
                            className="menu-link nav-link py-3 px-5 px-xxl-6"
                            href="/Pagenotfound.html"
                            data-kt-scroll-toggle="true"
                            data-kt-drawer-dismiss="true"
                          >
                            Login
                          </a>
                        </div>

                        <div className="menu-item flex-center  ms-5">
                          <a
                            href="/Pagenotfound.html"
                            className="btn getstartedBtn"
                          >
                            Get Started
                          </a>
                        </div>
                      </div>
                    </div>
                    <a className="d-lg-none d-sm-block" href="/">
                      <img
                        alt="Logo"
                        src="./assets/media/logos/3rdretaillogoblue.svg"
                        className="logo-default h-100px h-lg-100px"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
